var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_vm._v(" Thank you for your order "),_c('br'),_vm._v(" "+_vm._s(_vm._f("moment")(_vm.orderDetails.created))+" "),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.orderDetails)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }